import { render, staticRenderFns } from "./TrixEditor.vue?vue&type=template&id=55a3be1b&scoped=true&"
import script from "./TrixEditor.vue?vue&type=script&lang=js&"
export * from "./TrixEditor.vue?vue&type=script&lang=js&"
import style0 from "./TrixEditor.vue?vue&type=style&index=0&id=55a3be1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3be1b",
  null
  
)

export default component.exports